
import { Component, Vue, Prop } from 'vue-property-decorator'
import QrcodeVue from 'qrcode.vue'
import { IPublicShowcasePage } from '@/types/showcase'
import ProjectCard from "@/components/explore/ProjectCard.vue"
import ProjectExplore from '@/components/explore/ProjectExplore.vue'
import ShowcaseProjectExplore from '../ShowcaseProjectExplore.vue'
import ReadMoreBtn from '@/components/explore/hds/ReadMoreBtn.vue'
import ShowcaseLinks from './common/ShowcaseLinks.vue'
import ShowcaseDocuments from './common/ShowcaseDocuments.vue'
@Component({
  components: {
    QrcodeVue,
    ProjectCard,
    ProjectExplore,
    ShowcaseProjectExplore,
    ReadMoreBtn,
    ShowcaseLinks,
    ShowcaseDocuments
  }
})
export default class OverviewPage extends Vue {
  @Prop({ required: true }) showcasePage: IPublicShowcasePage

  get qrCodeHref () {
    const resolvedURL = this.$router.resolve({
      name: 'public-showcase',
      params: {
        slug: this.showcasePage.slug
      }
    })
    return resolvedURL
  }

  get showcaseLogo (): string {
    return this.showcasePage.logo.length > 0 ? this.showcasePage.logo[0].src : ''
  }

  get textBefore (): string {
    const maxLength = 150
    if (this.showcasePage.text.length <= maxLength) return this.showcasePage.text

    let truncated = this.showcasePage.text.substring(0, maxLength)
    const lastSpaceIndex = truncated.lastIndexOf(' ')
    if (lastSpaceIndex > 0) {
      truncated = truncated.substring(0, lastSpaceIndex)
    }
    return truncated + '...'
  }

  get pageHasProjects (): boolean {
    return this.showcasePage.projects.length > 0
  }

  get pageHasFundingCodes (): boolean {
    return this.showcasePage.funding_codes.length > 0
  }
}
